import { ApiService } from 'services';

export const GET_JURISDICTIONS_REQUEST = 'GET_JURISDICTIONS_REQUEST';
export const GET_JURISDICTIONS_FAILURE = 'GET_LANGUAGES_FAILURE';
export const GET_JURISDICTIONS_SUCCESS = 'GET_JURISDICTIONS_SUCCESS';

function request() {
  return {
    type: GET_JURISDICTIONS_REQUEST,
  };
}

function receive(data) {
  return {
    type: GET_JURISDICTIONS_SUCCESS,
    jurisdictions: data.data.jurisdictions,
    usTaxTreatyCountries: data.data.usTaxTreatyCountries
  };
}

export function getJurisdictions() {
  return (dispatch) => {
    dispatch(request());

    const promise = () => ApiService
      .getJurisdictions()
      .then((response) => {
        dispatch(receive(response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
      });
    return promise();
  };
}
